import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconTrash } from '../../../../../assets/icons/svg/shared/ic-shared-trash.svg';

export const InvoiceCancelSuccess = ({ invoiceNumber }: { invoiceNumber: string }) => {
  const { t } = useTranslation();
  return (
    <div className='text-bw00 text-lg font-metricR items-center justify-center flex'>
      <IconTrash className='stroke-bw00 text-bw00 mr-[10px]' />
      {t('INVOICE_HUB_MODALS.CANCEL_INVOICE.TOAST_SUCCESS.INVOICE')}
      <div className='flex mx-[5px]'>{`#${invoiceNumber}`}</div>
      <span className='font-metricRSemibold'>{t('INVOICE_HUB_MODALS.CANCEL_INVOICE.TOAST_SUCCESS.CANCELED')}</span>
    </div>
  );
};
